/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Pageable } from '../../models/pageable';
import { PagedModelProcessResponse } from '../../models/paged-model-process-response';

export interface ListProcesses$Params {
  pageable: Pageable;
}

export function listProcesses(http: HttpClient, rootUrl: string, params: ListProcesses$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelProcessResponse>> {
  const rb = new RequestBuilder(rootUrl, listProcesses.PATH, 'get');
  if (params) {
    rb.query('pageable', params.pageable, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedModelProcessResponse>;
    })
  );
}

listProcesses.PATH = '/processes';
